import { createSlice } from "@reduxjs/toolkit";

const initialState={
    voiceSelected:false,
}

const voiceSlice=createSlice({
    name:"voice",
    initialState,
    reducers:{
        changeVoiceSelected(state,action){
            state.voiceSelected=action.payload;
        },
    },
});

export const {changeVoiceSelected}=voiceSlice.actions;

export default voiceSlice.reducer;
